import { defineComponent as _defineComponent } from 'vue'

import { useRouter } from "vue-router";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const Router = useRouter()
const Store = useStore()
Router.beforeEach((to,from,next) => {
  Store.dispatch('getAllObjects')
  next()
})

return (_ctx: any,_cache: any) => {
  return null
}
}

})